import styled from 'styled-components'
import { colors } from '../../../theme/theme';

export const Container = styled.div`
   
    /* margin-left: calc(50vw - 800px); */
    margin-bottom: 32px;

    h4 { 
        font-size: 24px;
        
        color: ${colors.mainColors.blueberry};
        margin-bottom: 24px;
     }
`;

export const Main = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(240px, 0.3fr));
    grid-column-gap: 10px;
    grid-row-gap: 16px;


    /* @media only screen and (min-width: 1420px) { 
        grid-column-gap: 20px;
        grid-template-columns: repeat(auto-fit, minmax(255px, 0.3fr));
    } */

    @media only screen and (max-width: 1200px) { 
        grid-template-columns: repeat(auto-fit, minmax(240px, 0.3fr));
    }
`